import {actionTypes} from '../const';
const initialState = {
    printStatus:false
}
const printState = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GETPRINTDATA_SUCCESS:
            return Object.assign({}, state, {
                data:action.data
        });
        case actionTypes.PRINT_PROGRESS:
            return Object.assign({}, state, {
                printStatus:action.printStatus
        });
        default:
            return state;
    }
}
export default printState